import css from 'styled-jsx/css';
import typography from '../../../styles/typography';

export const styles = css`
    .FormInput {
      ${typography.h9}
    }
    .FormInput__Input {
      margin-bottom: 5px;
    }
    .FormInput__hint {
      color: var(--uiColors-globals-formControlHintText);
    }
    .FormInput__errorMessage {
      color: var(--uiColors-globals-formControlErrorText);
    }
  `;
